import { Toaster } from 'react-hot-toast'
import { TOKEN_COLOURS as TOKENS } from '@/theme/tokens'

/**
 * Existing toasts inherit mode changes without replacing their ids or timers.
 * A toast is a sentence to read, so it takes the sans body role, named by
 * variable in the inline style because the library's own unlayered stylesheet
 * would outrank a utility class.
 */
export function ApplicationToaster() {
  return (
    <Toaster
      position="top-right"
      toastOptions={{
        duration: 5000,
        style: {
          background: TOKENS.surface,
          color: TOKENS.text,
          border: `1px solid ${TOKENS.hairline}`,
          fontFamily: 'var(--font-sans)',
          fontSize: 'var(--text-body)',
          lineHeight: 'var(--text-body--line-height)',
        },
        iconTheme: {
          primary: TOKENS.now,
          secondary: TOKENS['on-accent'],
        },
        error: {
          iconTheme: {
            primary: TOKENS.error,
            secondary: TOKENS['on-accent'],
          },
          style: {
            border: `1px solid ${TOKENS.error}`,
          },
        },
        success: {
          iconTheme: {
            primary: TOKENS.success,
            secondary: TOKENS['on-accent'],
          },
          style: {
            border: `1px solid ${TOKENS.success}`,
          },
        },
      }}
    />
  )
}
